/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Assign_Speakers_CompleteInputs */



/**
* | output |
* | --- |
* | "Auto Assign Speakers Complete" |
*
* @param {Auto_Assign_Speakers_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_assign_speakers_complete = /** @type {((inputs?: Auto_Assign_Speakers_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Assign_Speakers_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribution automatique des intervenants terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Lautsprecherzuweisung abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnazione automatica altoparlanti completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое назначение динамиков завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignación automática de altavoces completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动分配发言人完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの自動割り当てが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर स्वतः असाइन करें (पूर्ण)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuição automática de alto-falantes concluída")
	return /** @type {LocalizedString} */ ("Auto Assign Speakers Complete")
});